import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular';
import { AccountProvider } from '../../providers/account/account';
import { AwsProvider } from '../../providers/aws/aws';

@IonicPage()
@Component({
  selector: 'page-edit-endpoints',
  templateUrl: 'edit-endpoints.html',
})
export class EditEndpointsPage {
	userRecord: object;
	fields: Array<any>;
  formData: object = {};
  showSpinner: boolean;
  errorMessages: Array<string> = [];
  showSuccess: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public accountPro: AccountProvider, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
  	// null in position 1 of each array means the field will not be validated.
  	// industry and agent get validated in their custom select functions.
  	// Position 2 contains the custom validation message for that field.
  	this.fields = [
  		['call', 'not undefined', 'Choose whether or not the client uses a call service.'],
  		['callType', 'not undefined', 'Select the call service used.'],
  		['callId', 'text', 'The call service id can not be blank.'],
  		['chat', 'not undefined', 'Choose whether or not the client uses a chat service.'],
  		['chatType', 'not undefined', 'Select the chat service used.'],
  		['chatId', 'text', 'The chat service id can not be blank.']
  	];
  	this.showSpinner = false;
		this.userRecord = this.navParams.get('userRecord');
		this.resetForm();
  }

  /**
   * Clear out all form fields and the form error messages
   */
  resetForm() {
  	this.errorMessages = [];
    this.showSuccess = false;
    console.log("resetting form");
    for (var i in this.fields) {
    	this.formData[this.fields[i][0]] = this.userRecord[this.fields[i][0]];
    }
  }

  /**
   * Assigns radio & select box choices to their formData field.
   */
  setField(field, value){
  	this.formData[field] = value;
  }

  /**
   * Check each field for validity, collect error messages for all bad fields, 
   * returns true if entire form is valid, false otherwise.
   */
  isFormValid() {
  	var valid: boolean = true;
    // if call == "on" then no choice was selected
    if(this.formData['call'] == "on"){
    	this.errorMessages.push(this.fields[0][2]);
    	valid = false;
    // If true, validate the other call fields
    } else if(this.formData['call'] === true){
			// validate call type is not undefined
			if(!this.formData['callType']){
				this.errorMessages.push(this.fields[1][2]);
				valid = false;
			}
    	// validate text for callId
    	if(!this.formData['callId'] || !this.validateTextInput('callId')){
				this.errorMessages.push(this.fields[2][2]);
				valid = false;
			}
	  }
	 	// if chat == "on" then no choice was selected
	  if(this.formData['chat'] == "on"){
    	this.errorMessages.push(this.fields[3][2]);
    	valid = false;
    // If true, validate the other call fields
    } else if(this.formData['chat'] === true){
			// validate call type is not undefined
			if(!this.formData['chatType']){
				this.errorMessages.push(this.fields[4][2]);
				valid = false;
			}
    	// validate text for callId
    	if(!this.formData['chatId'] && !this.validateTextInput('chatId')){
				this.errorMessages.push(this.fields[5][2]);
				valid = false;
			}
    }
    console.log("errorMessages");
    console.log(this.errorMessages);
    return valid;
  }

  validateTextInput(field: string) {
    return this.formData[field].trim().length > 0;
  }

  submit() {
  	this.errorMessages = [];
    if (this.isFormValid()) {
      console.log("validated");
      //this.showSuccess = true;
      this.showSpinner = true;
      this.errorMessages = [];
      this.editEndpoints();
    } else {
      console.log("not valid");
    	this.showSuccess = false;
    }
  }

  editEndpoints() {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    var data: object = {
    	'objectId': this.userRecord['objectId'],
    	'call': this.formData['call'],
    	'chat': this.formData['chat']
    };
    if(this.formData['call']){ 
    	data['callType'] = this.formData['callType'];
    	data['callId'] = this.formData['callId'].trim();
    }else{
    	data['callType'] = "none";
    	data['callId'] = "none";
    }
  	if(this.formData['chat']){ 
    	data['chatType'] = this.formData['chatType'];
    	data['chatId'] = this.formData['chatId'].trim();
    }else{
    	data['chatType'] = "none";
    	data['chatId'] = "none";
    }
    return this.accountPro.editEndpoints(data)
      .then((result) => {
        loading.dismiss();
        this.showSpinner = false;
        if (result['success'] === true) {
          //this.showSuccess = true;
          let msg = 'The endpoints were successfully edited.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        } else {
        	this.errorMessages.push(result['message']);
        	//this.showSuccess = false;
          let msg = 'Error editing endpoints. Please try again.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/edit-endpoints/edit-endpoints.ts